document.addEventListener('DOMContentLoaded', () => {
    initComplementary();
});

let comp_swiper = null;

function initComplementary() {
    const comp_sidebar = document.querySelector('#product-complementary-sidebar');

    let wrapper = document.querySelector('[data-js-complementary-wrapper]');
    if(wrapper) {
        const btn_list = wrapper.querySelectorAll('[data-js-complementary-btn]');
    
        if(btn_list.length > 0) {
            btn_list.forEach(btn => {
                const data = JSON.parse(btn.querySelector('.comp-data').textContent);
    
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
    
                    comp_sidebar.querySelector('.sidebar__close').addEventListener('click', resetComplementary);
                    document.querySelector('.site-overlay').addEventListener('click', resetComplementary);
    
                    btn.setAttribute('aria-expanded', 'true');
                    comp_sidebar.show();
                    
                    document.querySelector('.site-header-container').classList.add('mobile-slide-open');
    
                    getCompData(comp_sidebar, data);
                    addToCartEvent(comp_sidebar, data.variants);
                });
            });
        }
    }
}

// 사이드바 닫을 때 사이드바의 데이터들 초기화
function resetComplementary() {
    let sidebar = document.querySelector('#product-complementary-sidebar');

    sidebar.querySelector('.sidebar__title').textContent = '';
    sidebar.querySelector('.sidebar__footer .price').textContent = '';
    sidebar.querySelector('.sidebar__footer .cart-button').dataset.variantId = '';
    sidebar.querySelector('.complementary--swiper').swiper.destroy();
    sidebar.querySelector('.swiper-wrapper').innerHTML = '';
    sidebar.querySelector('.product-variants').innerHTML = '';
    sidebar.querySelector('.sidebar__close').removeEventListener('click', resetComplementary);
    document.querySelector('.site-overlay').removeEventListener('click', resetComplementary);
    btnExpandFalse();
}

function getCompData(sidebar, data) {
    if(data) {
        sidebar.querySelector('.sidebar__title').textContent = data.title;
        const swiper = sidebar.querySelector('.swiper');
        const swiper_wrapper = sidebar.querySelector('.swiper-wrapper');
        const variants = data.variants;

        if(variants.length > 0) {
            // 방법 1: spread operator 사용
            let variants_arr = variants; 
            if(variants.length > 2) {
                variants_arr = [...variants, ...variants];
            }

            variants_arr.forEach(item => {
                const slide = document.createElement('div');
                slide.classList.add('swiper-slide');
                slide.setAttribute('data-variant-id', item.id);
                slide.innerHTML = `<img src="${item.image}" alt="${item.title}">`;
                swiper_wrapper.appendChild(slide);
            });

            let swiper_loop = false;
            if(swiper.querySelectorAll('.swiper-slide').length > 2) {
                swiper_loop = true;
            }
            comp_swiper = new Swiper(swiper, {
                slidesPerView: 'auto',
                spaceBetween: 8,
                centeredSlides: true,
                loop: swiper_loop,
                // loopAdditionalSlides: variants.length,
            });
            // variant 옵션 초기화
            const comp_variants_div = sidebar.querySelector('.product-variants');
            const comp_options = data.options;

            if(comp_options.length > 0) {
                let variant_html = '';
                comp_options.forEach((option, idx) => {
                    let option_name = '';
                    switch(option.name) {
                        case '프레임':
                            option_name = 'frame';
                            break;
                        case '색상':
                            option_name = 'color';
                            break;
                        case '옵션':
                            option_name = 'option';
                            break;
                        default:
                            option_name = 'option-2';
                            break;
                    }

                    const option_values = option.values;

                    let option_name_html = '';
                    if(option.name == '프레임' || option.name == '색상') {
                        option_name_html = `<span class="product-variant__name">${option.name}</span>`;
                    }

                    let variant_item_html = '';
                    option_values.forEach((value, opt_idx) => {
                        let colorchip_html = '';
                        if(option.name == '프레임' || option.name == '색상') {
                            colorchip_html = `
                                <div class="color-chip">
                                    <div style="background-color: ${value.rgb};"></div>
                                </div>
                            `;
                        }
                        variant_item_html += `
                            <div class="product-variant__item product-variant__item--radio" data-option-id="${value.id}">
                                <input 
                                    type="radio" 
                                    id="${data.handle}-${value.id}" 
                                    name="${data.handle}-${option_name}" 
                                    value="${value.name}" 
                                    class="product-variant__input product-variant-value" 
                                    ${opt_idx == 0 ? 'checked' : ''}
                                >
                                <label for="${data.handle}-${value.id}" class="product-variant__label">
                                    ${colorchip_html}
                                    <div class="option-name">${value.name}</div>
                                </label>
                            </div>
                        `;
                    });

                    variant_html += `
                        <div class="product-variant depth-${idx + 1}" data-option="${option_name}">
                            ${option_name_html}
                            <div class="product-variant__container product-variant__container--radio product-variant__container--radio--wrap" data-js-product-variant-container="radio">
                                ${variant_item_html}
                            </div>
                        </div>
                    `;
                });

                comp_variants_div.innerHTML = variant_html;
            }

            filterVariantOptions(sidebar, data);

            const first_variant = variants[0];
            checkEventPrice(sidebar, first_variant);
            sidebar.querySelector('.sidebar__footer .cart-button').dataset.variantId = first_variant.id;
        }
    }
}

function filterVariantOptions(sidebar, data) {
    const variants = data.variants;
    const variantContainer = sidebar.querySelector('.product-variants');

    function handleOptionChange(changedDepth) {
        const selectedOptions = {
            depth1: variantContainer.querySelector('.depth-1 input:checked')?.value,
            depth2: variantContainer.querySelector('.depth-2 input:checked')?.value,
            depth3: variantContainer.querySelector('.depth-3 input:checked')?.value
        };

        // depth1이 변경되면 depth2, depth3 자동 선택
        if (changedDepth === 1) {
            if (selectedOptions.depth1) {
                filterDepth2Options(selectedOptions.depth1);
                // depth2의 첫번째 available 옵션 선택
                const firstAvailableDepth2 = variants.find(v => 
                    v.option1 === selectedOptions.depth1 && 
                    v.available
                )?.option2;
                
                if (firstAvailableDepth2) {
                    const depth2Input = variantContainer.querySelector(`.depth-2 input[value="${firstAvailableDepth2}"]`);
                    if (depth2Input) depth2Input.checked = true;
                    selectedOptions.depth2 = firstAvailableDepth2;
                }
            }
        }

        // depth2가 변경되면 depth3 자동 선택
        if (changedDepth <= 2 && selectedOptions.depth1 && selectedOptions.depth2) {
            filterDepth3Options(selectedOptions.depth1, selectedOptions.depth2);
            // depth3의 첫번째 available 옵션 선택
            const firstAvailableDepth3 = variants.find(v => 
                v.option1 === selectedOptions.depth1 && 
                v.option2 === selectedOptions.depth2 && 
                v.available
            )?.option3;

            if (firstAvailableDepth3) {
                const depth3Input = variantContainer.querySelector(`.depth-3 input[value="${firstAvailableDepth3}"]`);
                if (depth3Input) depth3Input.checked = true;
                selectedOptions.depth3 = firstAvailableDepth3;
            }
        }

        updateVariantPrice(selectedOptions);
    }

    // Depth 2 옵션 필터링
    function filterDepth2Options(depth1Value) {
        const depth2Items = variantContainer.querySelectorAll('.depth-2 .product-variant__item');
        depth2Items.forEach(item => {
            const input = item.querySelector('input');
            // 선택된 depth1과 조합 가능한 depth2 옵션만 표시
            const isPossibleOption = variants.some(v => 
                v.option1 === depth1Value && 
                v.option2 === input.value
            );

            item.style.display = isPossibleOption ? '' : 'none';
        });
    }

    // Depth 3 옵션 필터링
    function filterDepth3Options(depth1Value, depth2Value) {
        const depth3Items = variantContainer.querySelectorAll('.depth-3 .product-variant__item');
        depth3Items.forEach(item => {
            const input = item.querySelector('input');
            // 선택된 depth1, depth2와 조합 가능한 depth3 옵션만 표시
            const isPossibleOption = variants.some(v => 
                v.option1 === depth1Value && 
                v.option2 === depth2Value && 
                v.option3 === input.value
            );
            item.style.display = isPossibleOption ? '' : 'none';
        });
    }

    // 가격 업데이트
    function updateVariantPrice(selectedOptions) {
        Object.keys(selectedOptions).forEach(key => {
            if (selectedOptions[key] === undefined) {
                selectedOptions[key] = null;
            }
        });

        const selectedVariant = variants.find(v => 
            v.option1 === selectedOptions.depth1 && 
            (selectedOptions.depth2 ? v.option2 === selectedOptions.depth2 : true) && 
            (selectedOptions.depth3 ? v.option3 === selectedOptions.depth3 : true)
        );

        const cartButton = sidebar.querySelector('.sidebar__footer .cart-button');

        if (selectedVariant) {
            checkEventPrice(sidebar, selectedVariant);
            comp_swiper.slides.forEach(slide => {
                if(slide.getAttribute('data-variant-id') == selectedVariant.id) {
                    let swiper_idx = Number(slide.dataset.swiperSlideIndex);
                    comp_swiper.slideToLoop(swiper_idx);
                }
            });
            cartButton.dataset.variantId = selectedVariant.id;
            
            if (selectedVariant.available) {
                cartButton.classList.remove('disabled');
                cartButton.querySelector('.button__text').textContent = 'CART';
            } else {
                cartButton.classList.add('disabled');
                cartButton.querySelector('.button__text').textContent = '일시품절';
            }
        } else {
            cartButton.classList.add('disabled');
            cartButton.querySelector('.button__text').textContent = '일시품절';
        }
    }

    // 이벤트 리스너 수정
    variantContainer.querySelectorAll('.depth-1 input[type="radio"]').forEach(input => {
        input.addEventListener('change', () => handleOptionChange(1));
    });
    
    variantContainer.querySelectorAll('.depth-2 input[type="radio"]').forEach(input => {
        input.addEventListener('change', () => handleOptionChange(2));
    });
    
    variantContainer.querySelectorAll('.depth-3 input[type="radio"]').forEach(input => {
        input.addEventListener('change', () => handleOptionChange(3));
    });

    // 초기 필터링 실행
    handleOptionChange(1);
}

// 장바구니 추가 이벤트
function addToCartEvent(compSidebar, variants) {
    const addToCartButton = compSidebar.querySelector('.cart-button');
    if (addToCartButton) {
        addToCartButton.addEventListener('click', async () => {
            const variantId = addToCartButton.dataset.variantId;
            
            // variants 데이터에서 현재 선택된 variant의 available 상태 확인
            const selectedVariant = variants.find(v => v.id == variantId);
            if (!selectedVariant || !selectedVariant.available) {
                return; // 품절 상품은 카트 추가 중단
            }

            addToCartButton.classList.add('working');
            try {
                const formData = {
                    items: [{
                        id: variantId,
                        quantity: 1
                    }]
                };
    
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });
    
                if (!response.ok) {
                    const error = await response.json();
                    throw new Error(error.description || '카트에 추가하는데 실패했습니다.');
                }
    
                const result = await response.json();
                // 성공 메시지 표시
                if(result.items[0].id == variantId) {
                    compSidebar.querySelector('.sidebar__close').click();
                    refreshCart();
                }
    
            } catch (error) {
                console.error('Add to cart error:', error);
                alert(error.message);
            } finally {
                addToCartButton.classList.remove('working');
            }
        });
    }
}

function btnExpandFalse() {
    let btn_list = document.querySelectorAll('[data-js-complementary-btn]');
    btn_list.forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
    });
}

// 가격 판별
function checkEventPrice(sidebar, variant) {
    let price = Number(variant.price).toLocaleString('ko-KR');
    let specialPrice = variant.special_price;
    let eventStartDate = variant.event_start_dt;
    let eventEndDate = variant.event_end_dt;
    let isEvent = false;

    if(eventStartDate && eventEndDate) {
        const now = new Date();
        const start = new Date(eventStartDate);
        const end = new Date(eventEndDate);
        if(now >= start && now <= end) {
            isEvent = true;
        }
    }

    let priceNum = Number(price.replace(/,/g, ""));
    let specialPriceNum = Number(specialPrice.replace(/,/g, ""));

    if(isEvent) {
        if(priceNum <= specialPriceNum) {
            sidebar.querySelector('.sidebar__footer .price').textContent = `${price}원`;
        }
        else {
            sidebar.querySelector('.sidebar__footer .price').textContent = `${specialPrice}원`;
        }
    }
    else {
        sidebar.querySelector('.sidebar__footer .price').textContent = `${price}원`;
    }
}